<template>
  <div class="breadcrumb max-width">
    <span
      v-for="(item, index) in breadcrumb"
      :key="item.path"
      class="breadcrumb-item pointer"
      :class="{ current: index === breadcrumb.length - 1 }"
      @click="handleClick(item.path)"
    >
      {{ item.name }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'BreadCrumb',
  props: {
    breadcrumb: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  computed: {
    // breadcrumb() {
    //   console.log(this.$route)
    //   let matchedArr = this.$route.matched.map((item) => {
    //     const { path, name, meta } = item
    //     return { path, name, meta }
    //   })
    //   matchedArr.unshift({
    //     path: '/',
    //     name: '首页',
    //     meta: {
    //       title: '首页',
    //     },
    //   })
    //   // if (matchedArr[0].name !== '首页') {
    //   //   matchedArr.unshift({
    //   //     path: '/',
    //   //     name: '首页',
    //   //     meta: {
    //   //       title: '首页',
    //   //     },
    //   //   })
    //   // }
    //   console.log(matchedArr)
    //   return matchedArr
    // },
  },
  methods: {
    handleClick(path) {
      console.log(path)
      // this.$nextTick(() => {
      this.$router.push(path)
      // })
    },
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
